import { render, staticRenderFns } from "./provision-features.vue?vue&type=template&id=b952f274&scoped=true&"
import script from "./provision-features.vue?vue&type=script&lang=js&"
export * from "./provision-features.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b952f274",
  null
  
)

export default component.exports